import { useCallback, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as XLSX from "xlsx";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, Grid, ExcelUpload, FormControl, Table } from "@/comn/components";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
} from "@/comn/hooks";
import { BASE, URLS, APIS, SF_APP_ASIN_INFO, SF_APP_ASIN_NEW } from "./services/OsciLpcoAsinService";
import { CommonErrors } from "@/comn/components";
import { lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn";
import { UsrLstbyRole } from "../../comn/UsrLstbyRole";

/*
 * @ 화면 컴포넌트 주석
 * @ 메타 시스템을 참고 하여 표준 단어와 용어를 사용하여 작성
 * @ !== ... ==! 치환 부호는 개발 완료 후 한글 주석을 인지하여 제거하기 위한 표시
 * @ 기본 여러줄의 주석 형태를 사용
 * @ 포맷
 * @ [화면명 영문]
 * @ [지환부호시작] [화면명 한글] [치환부호종료]
 *
 * 화면명 영문
 * !== 화면명 한글 ==!
 */

/*
 * Modify LPCO Assignment
 * !== LPCO Assignment 수정 ==!
 */
export const OSCI0201027S = () => {
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0116" },
            { area: "comnCd", comnCd: "OSC0120" },
            { area: "comnCd", comnCd: "OSC0038" },
            { area: "comnCd", comnCd: "OSC0119" },
        ],
    });
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0002", "auth_osci0004"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const { appId } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!
    const [URLSearchParams] = useSearchParams();
    const { openPopup } = usePopup();
    const [lpcoAsinList, setLpcoAsinList] = useState(comnUtils.getGridData([]));

    const prcsCdList = useRef([]);
    /**
     * param
     */
    const asnmtBsopTpCd = URLSearchParams.get("asnmtBsopTpCd");
    const asnmtOfcrTpCd = URLSearchParams.get("asnmtOfcrTpCd");

    // original data
    const refOrginData = useRef({});

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Register LPCO Component !== LPCO Component 등록 ==!
        appAsinInfo: useForm({
            defaultSchema: SF_APP_ASIN_INFO,
            defaultValues: {},
        }),

        appAsinNewInfo: useForm({
            defaultSchema: SF_APP_ASIN_NEW,
            defaultValues: {},
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Component List !== Component 목록 ==!
        // lpcoAsinList: useGrid({
        //     defaultSchema: SG_LPCO_LIST_R,
        //     page: pgeStore?.page,
        //     size: pgeStore?.size,
        // }),
    };

    const render = {};

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        //return (await APIS.getLpcoCnptDtl(appFmId)).data?.appInfo.content || [];
        createChangeRspty: useFetch({
            api: (data) => APIS.createChangeRspty({ ...data }),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006" /**Processed successfully. */,
                    onConfirm: () => {
                        navigate(URLS.osci0201026q);
                    },
                    onCancel: () => {
                        navigate(URLS.osci0201026q);
                    },
                });
            },
            onError: (error) => {
                console.log(error);
                modal.openModal({
                    content: "msg.osc.00015",
                });
            },
        }),
        /* Register LPCO information !== LPCO 정보 등록 ==! */
        getRsptyInfo: useFetch({
            api: async (data) => await APIS.getRsptyInfo(data),
            onSuccess: (data) => {
                console.log("fetch data ", data);
                const info = data.rsptyInfo?.content.info || {};
                form.appAsinInfo.setValues({ ...info });
                form.appAsinNewInfo.setValues({
                    asnmtOfcrNm: info.asnmtOfcrNm,
                    asinOfcrId: info.asinOfcrId,
                    reffId: info.reffId,
                    orgCd: info.orgCd,
                    asnmtId: info.asnmtId,
                    amdTpCd: info.amdTpCd,
                });

                console.log("form.appAsinNewInfo", form.appAsinNewInfo.getValues());

                refOrginData.current = { ...info, excuUserId: info.asinOfcrId };
            },
            onError: (error) => {
                console.log("error ", error);

                console.log(error);
                let message = error.response?.data?.errorMessage || "msg.osc.00035";

                modal.openModal({
                    content: message,
                    onClose: () => {
                        navigate(`${URLS.osci0201026q}`);
                    },
                });

                //toast.showToast({ type: "error", content: "msg.osc.00035" });
            },
        }),
    };
    /*
     * 화면에서 사용하는 이벤트, 함수를 선언
     * 기본 변수명은 메타 단어 조합 카멜 표기법을 따름
     * fetch 를 호출 하는 메소드: fetch 명과 동일하게 작성
     * 버튼이나 그리드의 이벤트의 경우 : [이벤트종류]_[이벤트대상타입]_[이벤트대상명]
     * 이벤트 대상 타입 : Btn , Grid ... 카멜표기법으로 표시, 첫글자 대문자
     * 이벤트 명 : 카멜표기법으로 표시, 첫글자 대문자
     *
     * const handler = {
     *      [handler 이름] : ()=>{ 함수 },
     *      click_Btn_Save : 저장버튼 클릭
     *      click_Grid_RpckItmAppList : 재포장 품목 신청서 그리드 클릭
     *      ...
     * }
     */
    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    // ORG LIST
    const [orgCdList, setOrgCdList] = useState([]);
    // ORG LPCO LIST
    const [orgLpcoList, setOrgLpcoList] = useState([]);

    const handler = {
        createChangeRspty: form.appAsinNewInfo.handleSubmit(async () => {
            form.appAsinNewInfo.setValue("asnmtBsopTpCd", asnmtBsopTpCd);
            form.appAsinNewInfo.setValue("asnmtOfcrTpCd", asnmtOfcrTpCd);
            const data = { ...form.appAsinNewInfo.getValues() };

            console.log("save data ", data);

            modal.openModal({
                content: "msg.osc.00090" /**Do you want to save ? */,
                onConfirm: () => {
                    fetch.createChangeRspty.fetch(data);
                },
            });
        }),
        refreshOrgCdList: async () => {
            setOrgCdList((await lpcoUtils.getOrgCdList()) || []);
        },
        refreshOrgLpcoList: async (usrOrgCd: any) => {
            if (usrOrgCd) setOrgLpcoList((await lpcoUtils.getOrgLpcoList(usrOrgCd)) || []);
            else setOrgLpcoList([]);
        },
        setAppAsinDtl: async (data: any) => {
            console.log("setAppAsinDtl  ", data);
            fetch.getRsptyInfo.fetch(data);
        },
        onRsptySelected: (data: any) => {
            form.appAsinNewInfo.setValue("newAsnmtOfcrNm", data.label);
            form.appAsinNewInfo.setValue("newAsinOfcrId", data.code);
            form.appAsinNewInfo.setValue("newOrgCd", data.orgCd);

            console.log("form.appAsinNewInfo ", form.appAsinNewInfo.getValues());
        },
    };

    useEffect(() => {
        handler.setAppAsinDtl({
            appId: appId,
            asnmtBsopTpCd: asnmtBsopTpCd,
            asnmtOfcrTpCd: asnmtOfcrTpCd,
        }); // lpco app info
    }, []);

    return (
        <Page
        // id={pgeUid}
        // title={t("T_APP_ASNMT_MDFC")}
        // navigation={{
        //     base: comnEnvs.base,
        //     nodes: [
        //         ...BASE.nodes,
        //         { path: "/lpco/app/asin/osci0201026q", label: "T_ASNMT_LST" },
        //         { path: "/lpco/app/asin/osci0201027s/" + appFmId, label: "T_APP_ASNMT_MDFC" },
        //     ],
        // }}
        >
            <Group>
                <Group.Body>
                    <Group.Title title={"T_APP_ASNMT_INFO"} titleSize={2}></Group.Title>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.appAsinInfo.schema.orgNm} controlSize={10}></Group.Control>
                        </Group.Row>
                        {asnmtBsopTpCd == "ABO03" && (
                            <Group.Row>
                                <Group.Control {...form.appAsinInfo.schema.appNm} options={orgLpcoList}></Group.Control>
                                <Group.Control {...form.appAsinInfo.schema.ucrNo}></Group.Control>
                            </Group.Row>
                        )}
                        <Group.Row>
                            <Group.Control {...form.appAsinInfo.schema.appNo}></Group.Control>
                            {asnmtBsopTpCd != "ABO02" && (
                                <Group.Control {...form.appAsinInfo.schema.aplcTin}></Group.Control>
                            )}
                            {asnmtBsopTpCd == "ABO02" && (
                                <Group.Control {...form.appAsinInfo.schema.orgChpnNm}></Group.Control>
                            )}
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.appAsinInfo.schema.asnmtOfcrTpCd}></Group.Control>
                            <Group.Control {...form.appAsinInfo.schema.asnmtOfcrNm}></Group.Control>
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Title title={"T_APP_ASNMT_INFO"} titleSize={2}></Group.Title>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.appAsinNewInfo.schema.asnmtOfcrNm} controlSize={10}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.appAsinNewInfo.schema.newAsnmtOfcrNm}
                                controlSize={5}
                                rightButton={{
                                    icon: "search",
                                    onClick: () => {
                                        modal.openModal({
                                            // url 로 팝업창의 주소를 기입
                                            content: (
                                                <UsrLstbyRole
                                                    params={{ ...refOrginData.current }}
                                                    onSelected={handler.onRsptySelected}
                                                />
                                            ),
                                            // 팝업창에 보낼 파라메터 정의
                                            size: "md",
                                            draggable: true,
                                        });
                                    },
                                }}
                            ></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.appAsinNewInfo.schema.asinMdfyRsn} controlSize={10}></Group.Control>
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>

            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.osci0201026q);
                        }}
                    ></Button>
                    <Button
                        role="reset"
                        onClick={() => {
                            form.appAsinNewInfo.setValue("newAsnmtOfcrNm", "");
                            form.appAsinNewInfo.setValue("newAsinOfcrId", "");
                            form.appAsinNewInfo.setValue("asinMdfyRsn", "");
                        }}
                    ></Button>
                </Layout.Left>
                <Layout.Right>
                    <Button role="save" onClick={handler.createChangeRspty}></Button>
                    <Button role="cancel" onClick={() => navigate(`${URLS.osci0201026q}`)}></Button>
                </Layout.Right>
            </Layout>
        </Page>
    );
};
